export enum PrintHeaderLayoutType {
  None = 'None',
  FirstPage = 'FirstPage',
  AllPages = 'AllPages'
}
